import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Appcost(props) {
  return (
    <div className="p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Cloud-Sustainable">
              <h2>
                Boost Your Business with Our Expert Managed Cloud Services
              </h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              Are you ready to embrace the cloud-sustainable future? We deliver
              exceptional cloud management services in which our experts ensure
              cloud guidance, customizable solutions, end-to-end support, and
              expertise on multi-cloud technologies.
            </p>
            <p>
              We implement a modernized methodology to manage, monitor,
              optimize, and adapt your cloud operations. Start your journey with
              us today and get the power of the cloud to take the lead.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let's Connect!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Appcost;
